import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';

const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>Find Us</h1>
      <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">12 St, Mostar, Aščinica Misal,<br /> Bosnia and Hercegovina</p>
        <p className="p__opensans">+387-344-1230</p>
        <p className="p__opensans">+387-555-1230</p>
      <button type="button" className="custom__button" style={{ marginTop: '2rem' }}>Visit Us</button>
    </div>
    <div className="app__wrapper_img">
      <img src={images.findus} alt="finus_img" />
    </div>
  </div>
);

export default FindUs;
